export class UserModel {
  pk: number;
  deptPK: number;
  deptName: string;
  userID: string;
  userName: string;
  role: string;
  roleName: string;
  lenderPk: string;
  lenderName: string;
  isRetired: string;
  isRetiredName: string;
  createDate: string;
  editDate: string;
  photoUrl: string;
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/user.model.ts